import { REGEX_PATTERN } from "core/const/validator.const";

export const EmailField = [
  {
    type: "text",
    name: "username",
    label: "signIn.placeholder.username",
    validation: {
      required: "Email is required",
      pattern: {
        value: REGEX_PATTERN.email,
        message: "Please enter the valid email",
      },
    },
  },
];

export const PasswordField = [
  {
    type: "password",
    name: "password",
    label: "signIn.placeholder.password",
    validation: {
      required: "Password is required",
      maxLength: {
        value: 48,
        message: "Password must be within 48 characters",
      },
    },
  },
];
export const SigninResponseMessage = {
  success: "Login successful. Please wait..",
  error: "Invalid email or password.",
};
